import { render, staticRenderFns } from "./FormSave.vue?vue&type=template&id=1d1bcc8f&"
import script from "./FormSave.vue?vue&type=script&lang=js&"
export * from "./FormSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FormSave.vue"
export default component.exports